
import { defineComponent } from 'vue';

import { useStore } from 'vuex';
import { Actions } from '@/store';

import ModalHeader from '@/modules/modals/components/ModalHeader.vue';
import ModalFooter from '@/modules/modals/components/ModalFooter.vue';
import ModalBody from '@/modules/modals/components/ModalBody.vue';
import ModalService from '@/modules/modals/services/modalService';

import LogUsageManager from '@/manager/LogUsageManager';
import IComp from '@/models/Comp';

export default defineComponent({
    components: { ModalHeader, ModalBody, ModalFooter },
    props: ['comps'],
    data(props) {
        return {
            modal: null,
            compsList: props.comps
        };
    },
    setup() {
        const store = useStore();
        return {
            store
        };
    },
    mounted() {
        const modalElement = this.$refs.unVisitedComps;
        this.modal = ModalService.initialize(modalElement, this);
        ModalService.size(modalElement, '');
        ModalService.open(this.modal);
    },
    methods: {
        setCompAddress(comp: IComp) {
            let compLabel = '';
            const address = `${comp.address.address1}, ${comp.address.city}, ${comp.address.state} ${comp.address.zipCode}`;
            if (comp.compNumber === 0) {
                compLabel = `Subject - ${address}`;
            } else {
                compLabel = `Comp ${comp.compNumber} - ${address}`;
            }

            return compLabel;
        },
        async saveViewedProperties() {
            ModalService.hide(this.modal);
            (this as any).eventBus.emit('saveAndCloseFinal');
        }
    }
});
